import { setAuthToken } from '@app/api-client';
import type { UserDto } from '@app/contracts';
import { create } from 'zustand';

interface AuthState {
  user: UserDto | null;
  accessToken: string | null;
  setSession: (token: string, user: UserDto) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  setSession: (token, user) => {
    setAuthToken(token);
    set({ accessToken: token, user });
  },
  clearSession: () => {
    setAuthToken(null);
    set({ accessToken: null, user: null });
  },
}));
